import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';

import styles from './Tabs.module.scss';

const CustomSections = ({ tabs, activeKey, handleKey }) => {
  const setKey = (k) => handleKey(k);

  return (
    <div className={styles.tabs}>
      <Tabs id='controlled-tab-example' activeKey={activeKey} onSelect={setKey} className='mb-3'>
        {tabs.map((tab, index) => (
          <Tab key={index} className={styles.tabs__title} eventKey={tab.eventKey} title={tab.title}>
            {tab.child}
          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default CustomSections;
